import React, { useState, useEffect, useRef } from 'react';
import { Volume2, VolumeX } from 'lucide-react';
import { audioManager } from '../utils/audioManager';

const BackgroundMusic = () => {
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef(null);

  // Initialize audio
  useEffect(() => {
    const audio = new Audio('https://customer-assets.emergentagent.com/job_golden-ipmi-1/artifacts/0nzfomdh_Golden_Milestone_2025-11-04T165321.mp3');
    audio.preload = 'auto';
    audio.volume = 0.4;
    audio.loop = true;
    audioRef.current = audio;

    const handlePlay = () => {
      setIsPlaying(true);
      audioManager.setBackgroundMusic(audio, true);
    };
    
    const handlePause = () => {
      setIsPlaying(false);
      audioManager.setBackgroundMusic(audio, false);
    };

    audio.addEventListener('play', handlePlay);
    audio.addEventListener('pause', handlePause);

    // Try autoplay
    audio.play().then(() => {
      setIsPlaying(true);
    }).catch(() => {
      setIsPlaying(false);
    });

    return () => {
      audio.removeEventListener('play', handlePlay);
      audio.removeEventListener('pause', handlePause);
      audio.pause();
    };
  }, []);

  const toggleMusic = () => {
    const audio = audioRef.current;
    if (!audio) return;

    if (isPlaying) {
      audio.pause();
    } else {
      audio.volume = 0.4;
      audio.play().then(() => {
        setIsPlaying(true);
      }).catch((e) => {
        console.log('Play failed:', e);
      });
    }
  };

  return (
    <button
      onClick={toggleMusic}
      className={`music-control-button ${isPlaying ? 'playing' : 'muted'}`}
      aria-label={isPlaying ? 'Mute background music' : 'Play background music'}
      title={isPlaying ? 'Mute music' : 'Play music'}
      data-testid="music-toggle-btn"
    >
      {isPlaying ? (
        <Volume2 size={24} className="music-icon" />
      ) : (
        <VolumeX size={24} className="music-icon" />
      )}
      <div className="music-pulse-ring"></div>
    </button>
  );
};

export default BackgroundMusic;
